/**
 * Merges two data arrays (S1 and S2) by Timestamp.
 * Every field except Timestamp gets suffixed with _S1 or _S2.
 *
 * Example output row:
 * {
 *   Timestamp: 1772618400000,
 *   Online_S1: 21756,   Online_S2: 21800,
 *   Metering_S1: 23220, Metering_S2: 23500,
 *   Forecast_50_S1: 22191, Forecast_50_S2: 21400,
 *   ...
 * }
 */
const mergeCompareData = (s1Data, s2Data) => {
  if (!s1Data || !Array.isArray(s1Data)) return []
  if (!s2Data || !Array.isArray(s2Data)) {
    // If no S2, just suffix S1 keys so chart still works uniformly
    return s1Data.map(row => {
      const merged = { Timestamp: row.Timestamp }
      Object.keys(row).forEach(key => {
        if (key !== 'Timestamp') {
          merged[`${key}_S1`] = row[key]
        }
      })
      return merged
    })
  }

  // Build a Map keyed by Timestamp for S2 for O(n) lookup
  const s2Map = new Map()
  s2Data.forEach(row => {
    s2Map.set(row.Timestamp, row)
  })

  // Collect all unique timestamps from both datasets
  const allTimestamps = new Set()
  s1Data.forEach(row => allTimestamps.add(row.Timestamp))
  s2Data.forEach(row => allTimestamps.add(row.Timestamp))

  // Build S1 map too
  const s1Map = new Map()
  s1Data.forEach(row => {
    s1Map.set(row.Timestamp, row)
  })

  // Collect all field names (excluding Timestamp) from both
  const allKeys = new Set()
  if (s1Data.length > 0) {
    Object.keys(s1Data[0]).forEach(k => {
      if (k !== 'Timestamp') allKeys.add(k)
    })
  }
  if (s2Data.length > 0) {
    Object.keys(s2Data[0]).forEach(k => {
      if (k !== 'Timestamp') allKeys.add(k)
    })
  }

  // Sort timestamps ascending
  const sortedTimestamps = [...allTimestamps].sort((a, b) => a - b)

  return sortedTimestamps.map(ts => {
    const merged = { Timestamp: ts }
    const s1Row = s1Map.get(ts)
    const s2Row = s2Map.get(ts)

    allKeys.forEach(key => {
      merged[`${key}_S1`] = s1Row ? (s1Row[key] ?? null) : null
      merged[`${key}_S2`] = s2Row ? (s2Row[key] ?? null) : null
    })

    return merged
  })
}

export default mergeCompareData
